import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/user/advertising/programs")({
  staticData: { application: "Advertising" },
});
